import { createFileRoute, getRouteApi } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod/v4";
import { DocumentsLayout } from "../../../documents/DocumentsLayout";

const companyRoute = getRouteApi("/firmen/$companyId");

const searchSchema = z.object({
  kategorisieren: z.boolean().optional(),
  sortField: z.enum(["name", "createdAt"]).optional(),
  sortDirection: z.enum(["asc", "desc"]).optional(),
});

export const Route = createFileRoute(
  "/firmen/$companyId/dokumente/{-$documentId}"
)({
  validateSearch: zodValidator(searchSchema),
  loader: ({ context: { queryClient, trpc }, params: { documentId } }) => {
    if (documentId) {
      void queryClient.ensureQueryData(
        trpc.documents.getDocument.queryOptions({ documentId })
      );
    }
  },
  component: DokumenteRoute,
});

function DokumenteRoute() {
  const { companyId, documentId } = Route.useParams();
  const { jahr } = companyRoute.useSearch();

  return (
    <DocumentsLayout
      companyId={companyId}
      documentId={documentId}
      selectedYear={jahr}
    />
  );
}
